module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('DataTable', {
    staticClass: "p-datatable-responsive p-datatable-gridlines",
    attrs: {
      "value": _vm.roleLists,
      "paginator": true,
      "rows": 8,
      "filters": _vm.filters,
      "data-key": "id"
    }
  }, [_c('Column', {
    attrs: {
      "header": "S.N"
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function(slotProps) {
        return [_vm._v("\n        " + _vm._s(slotProps.index + 1) + "\n      ")]
      }
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Name",
      "field": "name",
      "filterMatchMode": "contains",
      "sortable": true
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['name']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'name', $$v)
            },
            expression: "filters['name']"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Action"
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function(slotProps) {
        return [_c('Button', {
          staticClass: "p-button-raised p-button-success",
          attrs: {
            "icon": "pi pi-pencil"
          },
          on: {
            "click": function($event) {
              return _vm.editRole(slotProps.data)
            }
          }
        }), _vm._v(" "), (!slotProps.data.systemOnly) ? _c('Button', {
          staticClass: "p-button-raised p-button-danger",
          attrs: {
            "icon": "pi pi-trash"
          },
          on: {
            "click": function($event) {
              return _vm.openDialog(slotProps.data.id)
            }
          }
        }) : _c('Button', {
          staticClass: "p-button-raised p-button-danger",
          attrs: {
            "disabled": "",
            "icon": "pi pi-trash"
          },
          on: {
            "click": function($event) {
              return _vm.openDialog(slotProps.data.id)
            }
          }
        })]
      }
    }])
  })], 1), _vm._v(" "), _c('Dialog', {
    on: {
      "deleted": _vm.deleteRole
    },
    model: {
      value: (_vm.dialogShow),
      callback: function($$v) {
        _vm.dialogShow = $$v
      },
      expression: "dialogShow"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-297de4e0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/settings/roleList.vue
// module id = 2107
// module chunks = 0